import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { SuccessIcon as b, CloseCircleIcon as v, SmallPenIcon as y } from "@systemeio/ui/icons";
import { twMerge as l } from "tailwind-merge";
import { FilePreviewFromOS as N } from "../file-preview-from-os/index.mjs";
import { FilePreview as k } from "../file-preview/index.mjs";
function I({
  file: e,
  isLoaded: s,
  isDeleting: u,
  className: c,
  disabled: a,
  disabledDeleteButton: t,
  showDeleteButton: m,
  showEditButton: p,
  childrenWrapper: d,
  childrenFileWrapper: f,
  onDeleteFile: i,
  onEdit: g
}) {
  const h = (() => {
    if (s)
      return /* @__PURE__ */ r(b, { className: "z-1 bg-background-primary animate-pop-up group absolute -top-2 -right-2 rounded-full" });
    if (m && i)
      return /* @__PURE__ */ r(
        "button",
        {
          type: "button",
          className: l(
            "z-1 bg-background-primary group absolute -top-2 -right-2 rounded-full",
            u && "animate-pulse"
          ),
          onClick: (o) => {
            o.preventDefault(), o.stopPropagation(), i();
          },
          disabled: t || a,
          children: /* @__PURE__ */ r(
            v,
            {
              className: l(
                "fill-text-secondary main-transition-colors",
                !t && !a && "group-hover:fill-brand-primary"
              )
            }
          )
        }
      );
  })();
  return /* @__PURE__ */ n(
    "div",
    {
      className: l("relative h-24 w-24", c),
      onClick: (o) => o.stopPropagation(),
      title: e.name,
      children: [
        h,
        /* @__PURE__ */ n("div", { className: "group/edit relative h-full w-full", children: [
          e instanceof File ? /* @__PURE__ */ r(N, { file: e, className: "h-full w-full rounded-md" }) : /* @__PURE__ */ r(
            k,
            {
              src: e.thumbnail || e.path,
              fileType: e.type,
              isThumbnail: !0,
              className: "h-full w-full rounded-md",
              title: e.name
            }
          ),
          /* @__PURE__ */ r(
            "div",
            {
              className: l(
                "bg-background-secondary/20 absolute top-0 left-0 hidden h-full w-full cursor-auto items-center justify-center rounded-md backdrop-blur-md",
                p && !a && "group-hover/edit:lg:flex flex lg:hidden"
              ),
              children: /* @__PURE__ */ r("div", { onClick: g, className: "group cursor-pointer p-2", children: /* @__PURE__ */ r(y, { className: "fill-background-secondary group-hover:fill-brand-primary main-transition-colors" }) })
            }
          ),
          f
        ] }),
        d
      ]
    }
  );
}
export {
  I as FileItemBase
};
